import { render, staticRenderFns } from "./SpotConfigurationLogs.vue?vue&type=template&id=bd8bf86c"
import script from "./SpotConfigurationLogs.vue?vue&type=script&lang=js"
export * from "./SpotConfigurationLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports